<template>
    <tr
        id="Inquiry_Row"
        :class="`border-line ${inquiry.id === editInProgressId || isDeleteRequested ? 'edit-row td-border' : ''} ${
            newInquiryId === inquiry.id ? 'table-info animated flash' : ''
        }`"
    >
        <td>{{ formatDateFromDate(inquiry.date) }}</td>
        <td>
            <FormatName :firstName="inquiry.firstName" :lastName="inquiry.lastName" />
            <br />
            <i class="me-2 fas fa-mobile-alt"></i>
            <a :href="`tel:${inquiry.phoneNumbers[0]?.number}`">{{ formatPhone(inquiry.phoneNumbers[0]?.number) }}</a>
        </td>
        <td>
            <span v-if="inquiry.contactFirstName"
                ><span v-if="inquiry.contactLastName">{{ inquiry.contactLastName }},</span>
                {{ inquiry.contactFirstName }}</span
            >

            <br />
            <span v-if="inquiry.contactPhoneNumbers[0]?.number">
                <i class="me-2 fas fa-mobile-alt"></i>
                <a :href="`tel:${inquiry.contactPhoneNumbers[0]?.number}`">{{
                    formatPhone(inquiry.contactPhoneNumbers[0]?.number)
                }}</a>
            </span>
        </td>
        <td>
            <EmptyTextHandler :text="inquiry.branchName" />
        </td>
        <td>
            <span v-if="inquiry.servicesRequested?.length > 0">
                {{ getLineOfService([...inquiry.servicesRequested]) }}</span
            >
            <span v-else>
                <span v-if="inquiryApplication"> {{ inquiryApplication }}</span>
                <small v-else><i class="text-default">Not Available</i></small>
            </span>
        </td>
        <td>
            <span v-if="inquiry.assignedUser?.length > 2">{{ inquiry.assignedUser }}</span>
            <small v-else><i class="text-default">Not Available</i></small>
        </td>
        <td>
            <span v-if="inquiry.followUpDate"> {{ formatDateFromDate(inquiry.followUpDate) }} </span>
            <small v-else><i class="text-default">Not Available</i></small>
        </td>
        <td class="text-center">
            <div class="big-text" v-if="inquiry.comment?.length > 0" v-tooltip="{ title: inquiry.comment }">
                <i class="far fa-comment-dots text-info"></i>
            </div>
            <span v-else><i class="text-default">Not Available</i></span>
        </td>
        <td class="text-end" v-show="!isDeleteRequested">
            <button
                type="button"
                class="btn table-btn px-2 btn-outline-info"
                @click="openEditInquiry(inquiry.application)"
                v-show="hasEditPermission && !editInProgressId"
                v-tooltip="{ title: actionButtonTooltipEnum.Edit }"
            >
                <i class="fas fa-edit icon-size"></i>
            </button>
            <button
                type="button"
                class="btn px-1 py-0 ms-1 btn-outline-primary icon-size"
                data-bs-toggle="dropdown"
                id="InquiryRow__Actions${id}"
            >
                <i class="fas fa-ellipsis-h icon-size"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="InquiryRow__Actions${id}">
                <a
                    class="dropdown-item"
                    v-if="isConvertAllowed"
                    href="javascript:void(0);"
                    @click="navigateToReferralPage()"
                >
                    Convert to Referral
                </a>
                <a
                    class="dropdown-item"
                    href="javascript:void(0);"
                    @click="confirmDeleteInquiry()"
                    v-if="inquiry.id !== editInProgressId && inquiry.canDelete"
                >
                    Delete
                </a>
            </div>
            <i v-if="inquiry.id == editInProgressId">Edit In Progress</i>
            <i v-if="!inquiry.canDelete && !inquiry.canEdit">No Actions</i>
        </td>
        <!-- DELETE -->
        <td colspan="4" v-if="isDeleteRequested">
            <TablePrompt
                ok-text="Delete"
                cancelText="Cancel"
                name="Inquiry"
                message="Do you want to delete this inquiry?"
                :includeYes="false"
                :isInProgress="isDeleteInProgress"
                :ok="deleteInquiry"
                :cancel="cancelDeleteInquiry"
            />
        </td>
    </tr>
    <!-- EDIT -->
    <tr v-if="isEditRequested" class="edit-row">
        <td :colspan="columns" class="p-3 edit">
            <InquiryForm
                v-if="isApplicationHospice || isApplicationPalliative"
                :inquiry="cachedData"
                :isLoading="isEditSaveInProgress"
                :serviceTypeEnums="serviceTypeEnums"
                :branches="branches"
                v-on:updateBranch="updateEditBranch"
            />
            <InquiryFormHomecareHomehealth
                v-if="isApplicationHomeCare || isApplicationHomehealth"
                :inquiry="cachedData"
                :isLoading="isEditSaveInProgress"
                :branches="branches"
                v-on:updateBranch="updateEditBranch"
                :isEdit="true"
            />
            <div class="text-center pt-3" v-if="!isEditSaveInProgress">
                <button type="button" class="btn btn-primary btn-md" @click="updateInquiry()">Save Inquiry</button>
                <button
                    v-if="isApplicationHospice || isApplicationPalliative"
                    type="button"
                    class="btn btn-success btn-md ms-2"
                    @click="handleConvertToReferral()"
                >
                    Convert To Referral
                </button>
                <button type="button" class="btn btn-outline-secondary btn-md ms-2" @click="closeEditInquiry()">
                    Cancel
                </button>
            </div>
        </td>
    </tr>
</template>

<script lang="ts" src="./CentralInquiryRow.ts"></script>
<style src="./CentralInquiryRow.scss" />
